import React from 'react';
import {concatenate} from "../../../services/string";

export enum Weekday {MO, TU, WE, TH, FR, SA, SU}

type Props = {
    days: Weekday[]
    onChange: (days: Weekday[]) => any
    disabled?: boolean
}

const weekdayLabels: Record<Weekday, string> = {
    [Weekday.MO]: 'Monday',
    [Weekday.TU]: 'Tuesday',
    [Weekday.WE]: 'Wednesday',
    [Weekday.TH]: 'Thursday',
    [Weekday.FR]: 'Friday',
    [Weekday.SA]: 'Saturday',
    [Weekday.SU]: 'Sunday',
}

function ByWeekdayCheckboxList({days, onChange, disabled}: Props) {

    const toggleWeekday = (weekday: Weekday) => {
        const enabled = !days.includes(weekday)
        const newDays = enabled ? [...days, weekday] : days.filter(day => day !== weekday)

        onChange(newDays)
    }

    return (
        <fieldset className="lg:flex lg:space-x-6">
            {Object.entries(weekdayLabels).map(([weekday, label]) => (
                <div key={weekday} className="mt-2 lg:mt-0 flex items-center">
                    <input
                        type="checkbox"
                        id={label.toLowerCase()}
                        name={`day[${label.toLowerCase()}]`}
                        value={weekday}
                        checked={days.includes(Number(weekday))}
                        onChange={() => toggleWeekday(Number(weekday))}
                        className={concatenate(
                          "h-4 w-4 rounded border-gray-300 focus:outline-none focus:ring-0 focus-visible:ring-2 focus-visible:ring-brand",
                          disabled ? 'text-gray-400' : 'text-brand',
                          disabled ? 'text-gray-400 cursor-not-allowed' : '',
                        )}
                        disabled={disabled}
                    />
                    <div className="ml-2 text-sm">
                        <label
                          htmlFor={label.toLowerCase()}
                          className={concatenate(
                            "font-medium",
                            disabled ? 'text-gray-400 cursor-not-allowed' : 'text-gray-700',
                          )}
                        >
                            {label}
                        </label>
                    </div>
                </div>
            ))}
        </fieldset>
    );
}

export default ByWeekdayCheckboxList;